// Mirror of Zenith-HRMS-Backend/constants/employeeFieldPolicy.js.
//
// The backend is the enforcing side — it rejects a sensitive field sent to the
// immediate-save endpoint regardless of what this file says. This copy only
// drives the UI: which inputs show a "pending approval" state, and how a change
// is routed on save. Keep the two lists in sync.

// Saved straight away when the employee clicks Save.
export const IMMEDIATE_FIELDS = [
  "address",
  "marital_status",
  "blood_group",
  "emergency_contact_name",
  "emergency_contact_phone",
  "two_factor_enabled",
];

// Saved as a pending request for Company Admin approval. Dot paths address
// subdocuments so a request names the exact field that changed.
export const APPROVAL_FIELDS = [
  "name",
  "phone",
  "bank_info.bank_name",
  "bank_info.account_number",
  "bank_info.ifsc_code",
  "bank_info.branch",
];

export const FIELD_LABELS = {
  name: "Full Name",
  phone: "Phone Number",
  "bank_info.bank_name": "Bank Name",
  "bank_info.account_number": "Account Number",
  "bank_info.ifsc_code": "IFSC Code",
  "bank_info.branch": "Branch",
};

// Not editable through self-service at all. `email` is the login identity, so
// it stays admin-only; the profile input for it is rendered disabled.
export const BLOCKED_FIELDS = ["email"];

export const isApprovalField = (field) => APPROVAL_FIELDS.includes(field);

export const labelFor = (field) => FIELD_LABELS[field] || field;

// Read "bank_info.account_number" off an employee/formData object.
export const readFieldPath = (source, path) =>
  path.split(".").reduce((acc, key) => (acc == null ? acc : acc[key]), source);

// Treat null/undefined/"" alike, and compare loosely enough that a stored
// number and a typed string do not look like an edit.
const normalize = (value) =>
  value === null || value === undefined ? "" : String(value).trim();

export const valuesMatch = (a, b) => normalize(a) === normalize(b);

/**
 * Compare edited form values against the saved record and return only the
 * approval-gated fields that actually changed, as { "dot.path": newValue }.
 */
export const collectApprovalChanges = (formData, employeeData) => {
  const changes = {};
  APPROVAL_FIELDS.forEach((field) => {
    const next = readFieldPath(formData, field);
    if (next === undefined) return;
    const current = readFieldPath(employeeData || {}, field);
    if (!valuesMatch(current, next)) changes[field] = next;
  });
  return changes;
};
